(function () {
  'use strict';

  var sbbNamespace = window.__SBB__ = window.__SBB__ || {};
  var ScaleBarBuilder = sbbNamespace.ScaleBarBuilder;
  var clamp = sbbNamespace.clamp;
  var parseNumber = sbbNamespace.parseNumber;
  var toFixedTrim = sbbNamespace.toFixedTrim;
  var deepClone = sbbNamespace.deepClone;
  var FONT_OPTIONS = sbbNamespace.fontOptions;
  var SHAPE_TYPES = sbbNamespace.shapeTypes;
  var MM_PER_CM = sbbNamespace.mmPerCm;
  var MM_PER_IN = sbbNamespace.mmPerIn;
  var DEFAULT_NOISE_COLOR_A = sbbNamespace.defaultNoiseColorA;
  var DEFAULT_NOISE_COLOR_B = sbbNamespace.defaultNoiseColorB;
  if (!ScaleBarBuilder || !clamp || !parseNumber || !toFixedTrim || !deepClone || !FONT_OPTIONS || !SHAPE_TYPES || !MM_PER_CM || !MM_PER_IN || !DEFAULT_NOISE_COLOR_A || !DEFAULT_NOISE_COLOR_B) {
    return;
  }

ScaleBarBuilder.prototype.handleInspectorEvent = function (event) {
    var target = event.target;
    if (!target || !target.dataset) {
      return;
    }
    if (this.isDeferredNumericInputEvent(event, target)) {
      return;
    }

    var field = target.dataset.inspectorField;
    var action = target.dataset.inspectorAction;
    var actionPayload = target.dataset.inspectorPayload || '';

    if (action) {
      this.handleInspectorAction(action, actionPayload);
      return;
    }

    if (!field || !this.state.selectedEntity) {
      return;
    }

    var paper = this.getPaper();

    if (this.state.selectedEntity.type === 'tag') {
      var tag = this.state.tags[this.state.selectedEntity.id];
      if (!tag) {
        return;
      }
      if (field === 'x') {
        var halfX = this.getTagSizeMm(this.state.selectedEntity.id) / 2;
        var printableTagX = this.getPrintableRect(paper, halfX);
        tag.xMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(tag.xMm))), printableTagX.minX, printableTagX.maxX);
      }
      if (field === 'y') {
        var halfY = this.getTagSizeMm(this.state.selectedEntity.id) / 2;
        var printableTagY = this.getPrintableRect(paper, halfY);
        tag.yMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(tag.yMm))), printableTagY.minY, printableTagY.maxY);
      }
      if (field === 'id') {
        var currentTagId = tag.id;
        var tagIdBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
        var requestedTagId = Math.round(parseNumber(target.value, currentTagId));
        var parsedTagId = clamp(Math.round(parseNumber(target.value, currentTagId)), tagIdBounds.min, tagIdBounds.max);
        var usedTagIds = {};
        var reservedTagIds = this.getReservedTagIdMapForCurrentScope();
        for (var ti = 0; ti < this.state.tagCount; ti += 1) {
          if (ti === this.state.selectedEntity.id || !this.state.tags[ti]) {
            continue;
          }
          usedTagIds[this.state.tags[ti].id] = true;
        }
        if (requestedTagId < tagIdBounds.min && currentTagId <= tagIdBounds.min) {
          tag.id = tagIdBounds.min;
          this.syncDynamicRows();
          this.render();
          return;
        }
        if (requestedTagId > tagIdBounds.max && currentTagId >= tagIdBounds.max) {
          tag.id = tagIdBounds.max;
          this.syncDynamicRows();
          this.render();
          return;
        }
        if (parsedTagId === currentTagId + 1) {
          tag.id = this.findNextUniqueViableTagId(currentTagId + 1, usedTagIds, reservedTagIds);
        } else if (parsedTagId === currentTagId - 1) {
          tag.id = this.findPrevUniqueViableTagId(currentTagId, usedTagIds, reservedTagIds);
        } else {
          tag.id = this.findNextUniqueViableTagId(parsedTagId, usedTagIds, reservedTagIds);
        }
        this.resolveUniqueViableTagIds();
        this.syncDynamicRows();
      }
      this.render();
      return;
    }

    if (this.state.selectedEntity.type === 'overlay') {
      var overlay = this.findOverlayById(this.state.selectedEntity.id);
      if (!overlay) {
        return;
      }

      if (field === 'x') {
        overlay.xMm = this.uiToMm(parseNumber(target.value, this.mmToUi(overlay.xMm)));
        if (overlay.id === this.logoOverlayId) {
          this.state.logoAutoPlacement = false;
        }
      }
      if (field === 'y') {
        overlay.yMm = this.uiToMm(parseNumber(target.value, this.mmToUi(overlay.yMm)));
        if (overlay.id === this.logoOverlayId) {
          this.state.logoAutoPlacement = false;
        }
      }
      if (field === 'w') {
        var printableOverlayRect = this.getPrintableRect(paper, 0);
        var maxOverlayWidthMm = Math.max(2, printableOverlayRect.maxX - printableOverlayRect.minX);
        overlay.wMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(overlay.wMm || 10))), 2, maxOverlayWidthMm);
        if (overlay.id === this.logoOverlayId) {
          this.state.logoAutoPlacement = false;
        }
      }
      if (field === 'h') {
        var printableOverlayRectH = this.getPrintableRect(paper, 0);
        var maxOverlayHeightMm = Math.max(2, printableOverlayRectH.maxY - printableOverlayRectH.minY);
        overlay.hMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(overlay.hMm || 10))), 2, maxOverlayHeightMm);
        if (overlay.id === this.logoOverlayId) {
          this.state.logoAutoPlacement = false;
        }
      }
      if (field === 'opacity') {
        overlay.opacity = clamp(parseNumber(target.value, overlay.opacity), 0, 1);
      }
      if (field === 'text') {
        overlay.text = target.value;
      }
      if (field === 'fontSize') {
        overlay.fontSizePt = clamp(parseNumber(target.value, this.getOverlayFontSizePt(overlay)), 4, 144);
      }
      if (field === 'fontFamily') {
        overlay.fontFamily = target.value || this.state.defaultFontFamily;
      }
      if (field === 'color') {
        overlay.color = target.value || '#000000';
      }
      if (field === 'align') {
        overlay.align = target.value || 'left';
      }
      if (field === 'shapeKind') {
        overlay.shapeKind = target.value || 'rectangle';
      }
      if (field === 'fillColor') {
        overlay.fillColor = target.value || '#000000';
      }
      if (field === 'strokeColor') {
        overlay.strokeColor = target.value || '#000000';
      }
      if (field === 'strokeWidth') {
        overlay.strokeWidthMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(parseNumber(overlay.strokeWidthMm, 0.4)))), 0, 20);
      }
      if (field === 'rows') {
        overlay.rows = clamp(Math.round(parseNumber(target.value, overlay.rows || 4)), 1, 32);
      }
      if (field === 'cols') {
        overlay.cols = clamp(Math.round(parseNumber(target.value, overlay.cols || 4)), 1, 32);
      }
      if (field === 'ringCount') {
        overlay.ringCount = clamp(Math.round(parseNumber(target.value, overlay.ringCount || 3)), 1, 20);
      }
      if (field === 'spokeCount') {
        overlay.spokeCount = clamp(Math.round(parseNumber(target.value, overlay.spokeCount || 8)), 1, 64);
      }
      if (field === 'armRatio') {
        overlay.armRatio = clamp(parseNumber(target.value, clamp(parseNumber(overlay.armRatio, 0.24), 0.12, 0.8) * 100) / 100, 0.12, 0.8);
      }
      if (field === 'showCoordinates') {
        overlay.showCoordinates = !!target.checked;
      }
      if (field === 'rotation') {
        overlay.rotationDeg = this.snapRotation15(parseNumber(target.value, overlay.rotationDeg || 0));
      }
      if (field === 'visible') {
        overlay.visible = !!target.checked;
      }
      if (field === 'locked') {
        overlay.locked = !!target.checked;
      }

      this.clampOverlayToPrintable(overlay, paper);

      this.render();
      return;
    }

    if (this.state.selectedEntity.type === 'reference') {
      var reference = this.getReferenceById(this.state.selectedEntity.id);
      if (!reference) {
        return;
      }
      var printableRefRect = this.getPrintableRect(paper, 0);
      var printableRefWidth = Math.max(0.2, printableRefRect.maxX - printableRefRect.minX);
      var printableRefHeight = Math.max(0.2, printableRefRect.maxY - printableRefRect.minY);

      if (field === 'x') {
        reference.xMm = this.uiToMm(parseNumber(target.value, this.mmToUi(reference.xMm)));
      }
      if (field === 'y') {
        reference.yMm = this.uiToMm(parseNumber(target.value, this.mmToUi(reference.yMm)));
      }
      if (field === 'length') {
        var newLength = this.uiToMm(parseNumber(target.value, this.mmToUi(reference.lengthMm)));
        var cellW = Math.max(0.2, reference.cellWidthMm);
        var count = Math.max(1, Math.round(newLength / cellW));
        reference.lengthMm = clamp(count * cellW, cellW, printableRefWidth);
      }
      if (field === 'cellWidth') {
        reference.cellWidthMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(reference.cellWidthMm))), 0.2, printableRefWidth);
        var countAfterWidth = Math.max(1, Math.round(reference.lengthMm / reference.cellWidthMm));
        reference.lengthMm = clamp(countAfterWidth * reference.cellWidthMm, reference.cellWidthMm, printableRefWidth);
      }
      if (field === 'cellHeight') {
        var currentRows = Math.max(1, Math.round(reference.rows || 1));
        var maxCellHeightMm = Math.max(0.2, printableRefHeight / currentRows);
        reference.cellHeightMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(reference.cellHeightMm))), 0.2, maxCellHeightMm);
      }
      if (field === 'rows') {
        var maxRowsFit = Math.max(1, Math.floor(printableRefHeight / Math.max(0.2, reference.cellHeightMm)));
        reference.rows = clamp(Math.round(parseNumber(target.value, reference.rows || 1)), 1, Math.min(32, maxRowsFit));
      }
      if (field === 'rotation') {
        reference.rotationDeg = this.snapRotation15(parseNumber(target.value, reference.rotationDeg || 0));
      }
      if (field === 'style') {
        reference.style = target.value || 'checker';
        if (!this.isReferenceRowStyle(reference.style)) {
          reference.rows = 1;
        }
      }
      if (field === 'unitSystem') {
        var nextRefUnit = String(target.value || '').toLowerCase() === 'imperial' ? 'imperial' : 'metric';
        if (reference.unitSystem !== nextRefUnit) {
          var prevRefCellW = Math.max(0.2, reference.cellWidthMm);
          var prevRefCells = Math.max(1, Math.round(reference.lengthMm / prevRefCellW));
          var nextCellW = nextRefUnit === 'imperial' ? MM_PER_IN : MM_PER_CM;
          var nextCellH = nextRefUnit === 'imperial' ? (MM_PER_IN / 4) : 5;
          reference.unitSystem = nextRefUnit;
          reference.cellWidthMm = clamp(nextCellW, 0.2, printableRefWidth);
          reference.cellHeightMm = clamp(nextCellH, 0.2, printableRefHeight / Math.max(1, reference.rows || 1));
          reference.lengthMm = clamp(reference.cellWidthMm * prevRefCells, reference.cellWidthMm, printableRefWidth);
        }
      }
      if (field === 'colorA') {
        reference.colorA = target.value || '#000000';
      }
      if (field === 'colorB') {
        reference.colorB = target.value || '#ffffff';
      }
      if (field === 'showLabel') {
        reference.showLabel = !!target.checked;
      }
      if (field === 'showScaleNumbers') {
        reference.showScaleNumbers = !!target.checked;
      }
      if (field === 'showUnitLabelInside') {
        reference.showUnitLabelInside = !!target.checked;
      }

      this.clampReferenceToPrintable(reference, paper);

      this.render();
    }
  };

  ScaleBarBuilder.prototype.handleInspectorAction = function (action, payload) {
    if (action === 'select-overlay') {
      this.state.selectedEntity = { type: 'overlay', id: payload };
      this.render();
      return;
    }

    if (action === 'select-reference') {
      this.state.selectedEntity = { type: 'reference', id: payload };
      this.render();
      return;
    }

    if (action === 'delete-reference') {
      this.state.references = (this.state.references || []).filter(function (item) {
        return item.id !== payload;
      });
      this.state.selectedEntity = null;
      this.render();
      return;
    }

    if (!this.state.selectedEntity || this.state.selectedEntity.type !== 'overlay') {
      if (action === 'tag-prev' && this.state.selectedEntity && this.state.selectedEntity.type === 'tag') {
        this.cycleTagId(this.state.selectedEntity.id, -1);
      }
      if (action === 'tag-next' && this.state.selectedEntity && this.state.selectedEntity.type === 'tag') {
        this.cycleTagId(this.state.selectedEntity.id, 1);
      }
      if (action === 'tag-delete' && this.state.selectedEntity && this.state.selectedEntity.type === 'tag') {
        this.deleteTagAtIndex(this.state.selectedEntity.id);
      }
      if (action === 'tag-toggle-relative') {
        this.state.showRelativeCoordinates = !this.state.showRelativeCoordinates;
        this.render();
      }
      if (action === 'distance-reset' && this.state.selectedEntity && this.state.selectedEntity.type === 'distance') {
        var selectedKey = this.state.selectedEntity.id;
        var selectedAnn = this.getDistanceAnnotation(selectedKey);
        this.state.distanceAnnotations[selectedKey] = { t: 0.5, normalOffsetMm: 0, hidden: !!selectedAnn.hidden };
        this.render();
      }
      if (action === 'distance-toggle' && this.state.selectedEntity && this.state.selectedEntity.type === 'distance') {
        var toggleKey = this.state.selectedEntity.id;
        var toggleAnn = this.getDistanceAnnotation(toggleKey);
        toggleAnn.hidden = !toggleAnn.hidden;
        this.state.distanceAnnotations[toggleKey] = toggleAnn;
        this.render();
      }
      return;
    }

    var overlay = this.findOverlayById(this.state.selectedEntity.id);
    if (!overlay) {
      return;
    }

    if (action === 'raise') {
      overlay.zIndex += 1;
    }
    if (action === 'lower') {
      overlay.zIndex -= 1;
    }
    if (action === 'delete') {
      if (overlay.type !== 'info' && overlay.type !== 'logo') {
        this.state.overlayItems = this.state.overlayItems.filter(function (item) {
          return item.id !== overlay.id;
        });
        this.state.selectedEntity = null;
      }
    }

    this.render();
  };

  ScaleBarBuilder.prototype.deleteSelectedEntity = function () {
    if (!this.state.selectedEntity) {
      return false;
    }

    if (this.state.selectedEntity.type === 'tag') {
      var tagIndex = Math.round(parseNumber(this.state.selectedEntity.id, NaN));
      if (!Number.isFinite(tagIndex) || tagIndex < 0 || tagIndex >= this.state.tagCount) {
        return false;
      }
      if (this.state.tagCount <= 1) {
        this.setStatus('At least one tag is required.', true);
        return false;
      }
      this.deleteTagAtIndex(tagIndex);
      return true;
    }

    if (this.state.selectedEntity.type === 'reference') {
      var refId = this.state.selectedEntity.id;
      this.state.references = (this.state.references || []).filter(function (item) {
        return item.id !== refId;
      });
      this.state.selectedEntity = null;
      this.render();
      this.commitHistory();
      return true;
    }

    if (this.state.selectedEntity.type === 'overlay') {
      var overlay = this.findOverlayById(this.state.selectedEntity.id);
      if (!overlay) {
        return false;
      }
      if (overlay.type === 'info' || overlay.type === 'logo') {
        this.setStatus('This overlay cannot be deleted.', true);
        return false;
      }
      var overlayId = overlay.id;
      this.state.overlayItems = this.state.overlayItems.filter(function (item) {
        return item.id !== overlayId;
      });
      this.state.selectedEntity = null;
      this.render();
      this.commitHistory();
      return true;
    }

    if (this.state.selectedEntity.type === 'distance') {
      var edgeKey = this.state.selectedEntity.id;
      var ann = this.getDistanceAnnotation(edgeKey);
      ann.hidden = true;
      this.state.distanceAnnotations[edgeKey] = ann;
      this.state.selectedEntity = null;
      this.render();
      this.commitHistory();
      return true;
    }

    if (this.state.selectedEntity.type === 'cut') {
      this.setStatus('Cut outline cannot be deleted.', true);
      return false;
    }
    if (this.state.selectedEntity.type === 'home') {
      this.setStatus('HOME origin cannot be deleted.', true);
      return false;
    }

    return false;
  };

  ScaleBarBuilder.prototype.canCopySelectedEntity = function () {
    if (!this.state.selectedEntity) {
      return false;
    }
    if (this.state.selectedEntity.type === 'tag') {
      return !!this.state.tags[this.state.selectedEntity.id];
    }
    if (this.state.selectedEntity.type === 'reference') {
      return !!this.getReferenceById(this.state.selectedEntity.id);
    }
    if (this.state.selectedEntity.type === 'overlay') {
      var overlay = this.findOverlayById(this.state.selectedEntity.id);
      if (!overlay) {
        return false;
      }
      return overlay.type !== 'info' && overlay.type !== 'logo';
    }
    return false;
  };

  ScaleBarBuilder.prototype.getClipboardOffsetMm = function () {
    return Math.max(2, parseNumber(this.getGridStepMm(), 1) * 2);
  };

  ScaleBarBuilder.prototype.copySelectedEntityToClipboard = function () {
    if (!this.canCopySelectedEntity()) {
      this.setStatus('Select a tag, reference, or overlay to copy.', true);
      return false;
    }
    var selected = this.state.selectedEntity;
    if (selected.type === 'tag') {
      var idx = selected.id;
      this.entityClipboard = {
        type: 'tag',
        data: {
          tag: deepClone(this.state.tags[idx]),
          sizeMm: this.getTagSizeMm(idx)
        }
      };
    } else if (selected.type === 'reference') {
      this.entityClipboard = {
        type: 'reference',
        data: deepClone(this.getReferenceById(selected.id))
      };
    } else if (selected.type === 'overlay') {
      var overlay = deepClone(this.findOverlayById(selected.id));
      delete overlay._computedXmm;
      delete overlay._computedYmm;
      delete overlay._computedWmm;
      delete overlay._computedHmm;
      delete overlay._computedRotationDeg;
      this.entityClipboard = {
        type: 'overlay',
        data: overlay
      };
    }
    this.updateToolButtonStates();
    this.setStatus('Copied selection.', false);
    return true;
  };

  ScaleBarBuilder.prototype.pasteClipboardEntity = function () {
    if (!this.entityClipboard || !this.entityClipboard.type || !this.entityClipboard.data) {
      this.setStatus('Clipboard is empty.', true);
      return false;
    }
    var paper = this.getPaper();
    var offsetMm = this.getClipboardOffsetMm();
    if (this.entityClipboard.type === 'overlay') {
      var sourceOverlay = deepClone(this.entityClipboard.data);
      var allowedTypes = { text: true, image: true, shape: true };
      if (!allowedTypes[sourceOverlay.type]) {
        this.setStatus('This overlay type cannot be pasted.', true);
        return false;
      }
      var prefix = sourceOverlay.type === 'text' ? 'overlay-text-' : (sourceOverlay.type === 'image' ? 'overlay-image-' : 'overlay-shape-');
      sourceOverlay.id = prefix + this.overlayCounter;
      this.overlayCounter += 1;
      sourceOverlay.xMm = parseNumber(sourceOverlay.xMm, 10) + offsetMm;
      sourceOverlay.yMm = parseNumber(sourceOverlay.yMm, 10) + offsetMm;
      sourceOverlay.zIndex = parseNumber(sourceOverlay.zIndex, 20) + 1;
      sourceOverlay.visible = sourceOverlay.visible !== false;
      sourceOverlay.locked = !!sourceOverlay.locked && sourceOverlay.type !== 'shape' ? true : !!sourceOverlay.locked;
      this.clampOverlayToPrintable(sourceOverlay, paper);
      this.state.overlayItems.push(sourceOverlay);
      this.state.selectedEntity = { type: 'overlay', id: sourceOverlay.id };
      this.render();
      this.commitHistory();
      this.setStatus('Overlay pasted.', false);
      return true;
    }
    if (this.entityClipboard.type === 'reference') {
      var sourceRef = deepClone(this.entityClipboard.data);
      sourceRef.id = 'ref-' + this.referenceCounter;
      this.referenceCounter += 1;
      sourceRef.xMm = parseNumber(sourceRef.xMm, 10) + offsetMm;
      sourceRef.yMm = parseNumber(sourceRef.yMm, 10) + offsetMm;
      sourceRef.rows = Math.max(1, Math.round(parseNumber(sourceRef.rows, 1)));
      sourceRef.rotationDeg = this.normalizeRotation(parseNumber(sourceRef.rotationDeg, 0));
      sourceRef.unitSystem = this.getReferenceUnitSystem(sourceRef);
      sourceRef.showUnitLabelInside = !!sourceRef.showUnitLabelInside;
      this.clampReferenceToPrintable(sourceRef, paper);
      this.state.references.push(sourceRef);
      this.state.selectedEntity = { type: 'reference', id: sourceRef.id };
      this.render();
      this.commitHistory();
      this.setStatus('Reference pasted.', false);
      return true;
    }
    if (this.entityClipboard.type === 'tag') {
      var sourceTag = deepClone(this.entityClipboard.data.tag || {});
      var sourceSizeMm = clamp(parseNumber(this.entityClipboard.data.sizeMm, this.state.tagSizeMm), 8, 180);
      var candidateX = parseNumber(sourceTag.xMm, paper.width / 2) + offsetMm;
      var candidateY = parseNumber(sourceTag.yMm, paper.height / 2) + offsetMm;
      var printable = this.getPrintableRect(paper, sourceSizeMm / 2);
      candidateX = clamp(this.snapCenterToGrid(candidateX, this.getGridStepMm(), paper.width / 2), printable.minX, printable.maxX);
      candidateY = clamp(this.snapCenterToGrid(candidateY, this.getGridStepMm(), paper.height / 2), printable.minY, printable.maxY);
      for (var tryIndex = 0; tryIndex < 40 && this.doesGuideOverlapExistingTag(candidateX, candidateY, sourceSizeMm, null, this.state.tags); tryIndex += 1) {
        candidateX = clamp(candidateX + offsetMm, printable.minX, printable.maxX);
        candidateY = clamp(candidateY + offsetMm, printable.minY, printable.maxY);
      }
      this.switchToManualMode();
      var usedIds = {};
      var reservedIds = this.getReservedTagIdMapForCurrentScope();
      for (var i = 0; i < this.state.tagCount; i += 1) {
        usedIds[this.state.tags[i].id] = true;
      }
      var nextTagId = this.findNextUniqueViableTagId(parseNumber(sourceTag.id, 0), usedIds, reservedIds);
      this.state.tags.push({
        id: nextTagId,
        xMm: candidateX,
        yMm: candidateY
      });
      this.ensureTagSizes();
      this.state.tagSizesMm.push(sourceSizeMm);
      this.state.tagCount += 1;
      this.controls.tagCount.value = this.state.tagCount;
      this.state.selectedEntity = { type: 'tag', id: this.state.tagCount - 1 };
      this.syncDynamicRows();
      this.render();
      this.commitHistory();
      this.setStatus('Tag pasted.', false);
      return true;
    }
    return false;
  };

  ScaleBarBuilder.prototype.duplicateSelectedEntity = function () {
    if (!this.copySelectedEntityToClipboard()) {
      return false;
    }
    return this.pasteClipboardEntity();
  };

  ScaleBarBuilder.prototype.getLayerEntriesForPanel = function () {
    var entries = [];
    var refs = Array.isArray(this.state.references) ? this.state.references : [];
    var tags = Array.isArray(this.state.tags) ? this.state.tags : [];
    var overlays = Array.isArray(this.state.overlayItems) ? this.state.overlayItems : [];
    var home = this.getHomePoint();
    var selected = this.state.selectedEntity || null;
    var i;

    for (i = 0; i < refs.length; i += 1) {
      var ref = refs[i];
      if (!ref || !ref.id) {
        continue;
      }
      entries.push({
        type: 'reference',
        id: ref.id,
        label: 'reference ' + (i + 1),
        visible: ref.visible !== false,
        drawZ: 20 + i,
        active: !!(selected && selected.type === 'reference' && selected.id === ref.id),
        draggable: true,
        movable: true
      });
    }

    for (i = 0; i < tags.length; i += 1) {
      var tag = tags[i];
      if (!tag) {
        continue;
      }
      entries.push({
        type: 'tag',
        id: String(i),
        label: 'tag ' + (i + 1) + ' (' + this.getTagDisplayCode(tag.id) + ')',
        visible: true,
        drawZ: 100 + i,
        active: !!(selected && selected.type === 'tag' && selected.id === i),
        draggable: false,
        movable: false,
        toggleable: false
      });
    }

    if (home) {
      entries.push({
        type: 'home',
        id: 'home',
        label: 'HOME origin',
        visible: home.visible !== false,
        drawZ: 94,
        active: !!(selected && selected.type === 'home'),
        draggable: false,
        movable: false,
        toggleable: true
      });
    }

    for (i = 0; i < overlays.length; i += 1) {
      var overlay = overlays[i];
      if (!overlay || !overlay.id) {
        continue;
      }
      entries.push({
        type: 'overlay',
        id: overlay.id,
        label: overlay.type + ' (' + overlay.id + ')',
        visible: overlay.visible !== false,
        drawZ: 60 + parseNumber(overlay.zIndex, 0),
        active: !!(selected && selected.type === 'overlay' && selected.id === overlay.id),
        draggable: true,
        movable: true,
        toggleable: true
      });
    }

    entries.sort(function (a, b) {
      if (b.drawZ !== a.drawZ) {
        return b.drawZ - a.drawZ;
      }
      if (a.type !== b.type) {
        return a.type < b.type ? -1 : 1;
      }
      if (a.id < b.id) {
        return -1;
      }
      if (a.id > b.id) {
        return 1;
      }
      return 0;
    });

    return entries;
  };

  ScaleBarBuilder.prototype.getSelectedLayerEntry = function () {
    if (!this.state.selectedEntity) {
      return null;
    }
    if (this.state.selectedEntity.type === 'tag') {
      var tagIndex = clamp(Math.round(parseNumber(this.state.selectedEntity.id, -1)), 0, Math.max(0, this.state.tagCount - 1));
      var selectedTag = this.state.tags[tagIndex];
      if (!selectedTag) {
        return null;
      }
      return {
        type: 'tag',
        id: String(tagIndex),
        visible: true,
        label: 'tag ' + (tagIndex + 1) + ' (' + this.getTagDisplayCode(selectedTag.id) + ')',
        movable: false,
        toggleable: false
      };
    }
    if (this.state.selectedEntity.type === 'overlay') {
      var overlay = this.findOverlayById(this.state.selectedEntity.id);
      if (!overlay) {
        return null;
      }
      return {
        type: 'overlay',
        id: overlay.id,
        visible: overlay.visible !== false,
        label: overlay.type + ' (' + overlay.id + ')',
        movable: true,
        toggleable: true
      };
    }
    if (this.state.selectedEntity.type === 'reference') {
      var ref = this.getReferenceById(this.state.selectedEntity.id);
      if (!ref) {
        return null;
      }
      return {
        type: 'reference',
        id: ref.id,
        visible: ref.visible !== false,
        label: 'reference (' + ref.id + ')',
        movable: true,
        toggleable: true
      };
    }
    if (this.state.selectedEntity.type === 'home') {
      var home = this.getHomePoint();
      if (!home) {
        return null;
      }
      return {
        type: 'home',
        id: 'home',
        visible: home.visible !== false,
        label: 'HOME origin',
        movable: false,
        toggleable: true
      };
    }
    return null;
  };

  ScaleBarBuilder.prototype.renderLayersPanel = function () {
    if (!this.controls.layersPanel) {
      return;
    }
    var selectedLayer = this.getSelectedLayerEntry();
    var selectedActionsList = [];
    if (selectedLayer && selectedLayer.movable) {
      selectedActionsList.push('<button type="button" class="sbb-button small xs" data-layer-action="selected-up">Up</button>');
      selectedActionsList.push('<button type="button" class="sbb-button small xs" data-layer-action="selected-down">Down</button>');
    }
    if (selectedLayer && selectedLayer.toggleable !== false) {
      selectedActionsList.push('<button type="button" class="sbb-button small xs" data-layer-action="selected-toggle-visible">' + (selectedLayer.visible ? 'Hide' : 'Show') + '</button>');
    }
    var selectedSummary = selectedLayer
      ? ('Selected: ' + selectedLayer.label)
      : 'Select a layer to manage order and visibility.';
    var selectedActions = selectedActionsList.join('');

    var entries = this.getLayerEntriesForPanel();
    if (!entries.length) {
      this.controls.layersPanel.innerHTML = [
        '<div class="sbb-layer-toolbar">',
        '  <span class="sbb-shelf-note">' + selectedSummary + '</span>',
        '  <div class="sbb-layer-toolbar-actions">' + selectedActions + '</div>',
        '</div>',
        '<div class="sbb-note">No layers available.</div>'
      ].join('');
      return;
    }

    if (!this.layerPanelGroupState || typeof this.layerPanelGroupState !== 'object') {
      this.layerPanelGroupState = { tags: true };
    }
    var existingTagsGroup = this.controls.layersPanel.querySelector('[data-layer-group="tags"]');
    if (existingTagsGroup) {
      this.layerPanelGroupState.tags = !!existingTagsGroup.open;
    }

    var renderLayerRow = function (entry) {
      var rowDraggable = entry.draggable !== false;
      var classes = ['sbb-layer-item'];
      if (entry.active) {
        classes.push('is-active');
      }
      if (!entry.visible) {
        classes.push('is-hidden');
      }
      var toggleMarkup = entry.toggleable === false
        ? '<span class="sbb-layer-toggle sbb-layer-toggle-static">Shown</span>'
        : (
          '<label class="sbb-layer-toggle">' +
          '  <input type="checkbox" data-layer-action="toggle-visible" data-layer-type="' + entry.type + '" data-layer-id="' + entry.id + '"' + (entry.visible ? ' checked' : '') + ' />' +
          '  <span>' + (entry.visible ? 'Shown' : 'Hidden') + '</span>' +
          '</label>'
        );
      return (
        '<div class="' + classes.join(' ') + '" draggable="' + (rowDraggable ? 'true' : 'false') + '" data-layer-row data-layer-draggable="' + (rowDraggable ? '1' : '0') + '" data-layer-type="' + entry.type + '" data-layer-id="' + entry.id + '">' +
        '  <span class="sbb-layer-grip' + (rowDraggable ? '' : ' is-static') + '" title="' + (rowDraggable ? 'Drag to reorder' : 'Fixed layer') + '">' + (rowDraggable ? '::' : '--') + '</span>' +
        '  <button type="button" class="sbb-layer-main" data-layer-action="select" data-layer-type="' + entry.type + '" data-layer-id="' + entry.id + '">' +
        '    <span class="sbb-layer-label">' + entry.label + '</span>' +
        '    <span class="sbb-layer-z">Z' + entry.drawZ + '</span>' +
        '  </button>' +
        '  ' + toggleMarkup +
        '</div>'
      );
    };

    var tagEntries = [];
    var otherEntries = [];
    for (var e = 0; e < entries.length; e += 1) {
      if (entries[e].type === 'tag') {
        tagEntries.push(entries[e]);
      } else {
        otherEntries.push(entries[e]);
      }
    }

    var html = [
      '<div class="sbb-layer-toolbar">',
      '  <span class="sbb-shelf-note">' + selectedSummary + '</span>',
      '  <div class="sbb-layer-toolbar-actions">' + selectedActions + '</div>',
      '</div>',
      '<div class="sbb-layer-stack" data-layer-stack>'
    ];

    if (tagEntries.length) {
      html.push(
        '<details class="sbb-layer-group" data-layer-group="tags"' + (this.layerPanelGroupState.tags !== false ? ' open' : '') + '>' +
        '  <summary>Tags / Targets (' + tagEntries.length + ')</summary>' +
        '  <div class="sbb-layer-group-body">'
      );
      for (var t = 0; t < tagEntries.length; t += 1) {
        html.push(renderLayerRow(tagEntries[t]));
      }
      html.push('  </div></details>');
    }

    for (var i = 0; i < otherEntries.length; i += 1) {
      html.push(renderLayerRow(otherEntries[i]));
    }

    html.push('</div>');
    this.controls.layersPanel.innerHTML = html.join('');
  };

  ScaleBarBuilder.prototype.setLayerVisibility = function (layerType, layerId, visible) {
    if (layerType === 'tag') {
      return false;
    }
    if (layerType === 'overlay') {
      var overlay = this.findOverlayById(layerId);
      if (!overlay) {
        return false;
      }
      overlay.visible = !!visible;
      return true;
    }
    if (layerType === 'reference') {
      var ref = this.getReferenceById(layerId);
      if (!ref) {
        return false;
      }
      ref.visible = !!visible;
      return true;
    }
    if (layerType === 'home') {
      var home = this.getHomePoint();
      if (!home) {
        return false;
      }
      home.visible = !!visible;
      return true;
    }
    return false;
  };

  ScaleBarBuilder.prototype.moveSelectedLayerBy = function (delta) {
    var selectedLayer = this.getSelectedLayerEntry();
    if (!selectedLayer) {
      return false;
    }
    var direction = delta < 0 ? -1 : 1;
    if (selectedLayer.type === 'overlay') {
      var overlayOrder = (this.state.overlayItems || []).slice().sort(function (a, b) {
        return parseNumber(b.zIndex, 0) - parseNumber(a.zIndex, 0);
      });
      var oi = -1;
      for (var o = 0; o < overlayOrder.length; o += 1) {
        if (overlayOrder[o].id === selectedLayer.id) {
          oi = o;
          break;
        }
      }
      if (oi < 0) {
        return false;
      }
      var nextOi = clamp(oi + direction, 0, overlayOrder.length - 1);
      if (nextOi === oi) {
        return false;
      }
      var movingOverlay = overlayOrder.splice(oi, 1)[0];
      overlayOrder.splice(nextOi, 0, movingOverlay);
      var overlayBottomToTop = overlayOrder.slice().reverse();
      for (var z = 0; z < overlayBottomToTop.length; z += 1) {
        overlayBottomToTop[z].zIndex = z + 1;
      }
      return true;
    }
    if (selectedLayer.type === 'reference') {
      var referenceTopOrder = (this.state.references || []).slice().reverse();
      var ri = -1;
      for (var r = 0; r < referenceTopOrder.length; r += 1) {
        if (referenceTopOrder[r].id === selectedLayer.id) {
          ri = r;
          break;
        }
      }
      if (ri < 0) {
        return false;
      }
      var nextRi = clamp(ri + direction, 0, referenceTopOrder.length - 1);
      if (nextRi === ri) {
        return false;
      }
      var movingRef = referenceTopOrder.splice(ri, 1)[0];
      referenceTopOrder.splice(nextRi, 0, movingRef);
      this.state.references = referenceTopOrder.reverse();
      return true;
    }
    return false;
  };

  ScaleBarBuilder.prototype.reorderLayerEntryByDrop = function (dragType, dragId, targetType, targetId, placeAfter) {
    if (!dragType || !targetType || dragType !== targetType || !dragId || !targetId || dragId === targetId) {
      return false;
    }
    var after = !!placeAfter;
    if (dragType === 'overlay') {
      var overlayTopOrder = (this.state.overlayItems || []).slice().sort(function (a, b) {
        return parseNumber(b.zIndex, 0) - parseNumber(a.zIndex, 0);
      });
      var fromIdx = -1;
      var toIdx = -1;
      var i;
      for (i = 0; i < overlayTopOrder.length; i += 1) {
        if (overlayTopOrder[i].id === dragId) {
          fromIdx = i;
        }
        if (overlayTopOrder[i].id === targetId) {
          toIdx = i;
        }
      }
      if (fromIdx < 0 || toIdx < 0) {
        return false;
      }
      var nextIdx = toIdx + (after ? 1 : 0);
      var movingOverlay = overlayTopOrder.splice(fromIdx, 1)[0];
      if (fromIdx < nextIdx) {
        nextIdx -= 1;
      }
      nextIdx = clamp(nextIdx, 0, overlayTopOrder.length);
      overlayTopOrder.splice(nextIdx, 0, movingOverlay);
      var overlayBottom = overlayTopOrder.slice().reverse();
      for (i = 0; i < overlayBottom.length; i += 1) {
        overlayBottom[i].zIndex = i + 1;
      }
      return true;
    }
    if (dragType === 'reference') {
      var referenceTopOrder = (this.state.references || []).slice().reverse();
      var refFrom = -1;
      var refTo = -1;
      var j;
      for (j = 0; j < referenceTopOrder.length; j += 1) {
        if (referenceTopOrder[j].id === dragId) {
          refFrom = j;
        }
        if (referenceTopOrder[j].id === targetId) {
          refTo = j;
        }
      }
      if (refFrom < 0 || refTo < 0) {
        return false;
      }
      var refNext = refTo + (after ? 1 : 0);
      var movingRef = referenceTopOrder.splice(refFrom, 1)[0];
      if (refFrom < refNext) {
        refNext -= 1;
      }
      refNext = clamp(refNext, 0, referenceTopOrder.length);
      referenceTopOrder.splice(refNext, 0, movingRef);
      this.state.references = referenceTopOrder.reverse();
      return true;
    }
    return false;
  };

  ScaleBarBuilder.prototype.clearLayerDropMarkers = function () {
    if (!this.controls.layersPanel) {
      return;
    }
    var rows = this.controls.layersPanel.querySelectorAll('[data-layer-row]');
    for (var i = 0; i < rows.length; i += 1) {
      rows[i].classList.remove('drop-before');
      rows[i].classList.remove('drop-after');
      rows[i].removeAttribute('data-layer-drop-after');
    }
  };

  ScaleBarBuilder.prototype.getOverlayLayerListMarkup = function () {
    if (!this.state.overlayItems || this.state.overlayItems.length === 0) {
      return '<div class="sbb-note">No overlay items.</div>';
    }

    var sorted = this.state.overlayItems.slice().sort(function (a, b) {
      return b.zIndex - a.zIndex;
    });

    var html = ['<div class="sbb-layer-list">'];
    for (var i = 0; i < sorted.length; i += 1) {
      var item = sorted[i];
      var active = this.state.selectedEntity && this.state.selectedEntity.type === 'overlay' && this.state.selectedEntity.id === item.id;
      html.push(
        '<button type="button" class="sbb-layer-row' + (active ? ' active' : '') + '" data-inspector-action="select-overlay" data-inspector-payload="' + item.id + '">' +
        '<span>' + item.type + '</span><span>Z' + item.zIndex + '</span>' +
        '</button>'
      );
    }
    html.push('</div>');
    return html.join('');
  };

  ScaleBarBuilder.prototype.getReferenceLayerListMarkup = function () {
    if (!Array.isArray(this.state.references) || this.state.references.length === 0) {
      return '<div class="sbb-note">No references.</div>';
    }
    var html = ['<div class="sbb-layer-list">'];
    for (var i = 0; i < this.state.references.length; i += 1) {
      var ref = this.state.references[i];
      var active = this.state.selectedEntity && this.state.selectedEntity.type === 'reference' && this.state.selectedEntity.id === ref.id;
      html.push(
        '<button type="button" class="sbb-layer-row' + (active ? ' active' : '') + '" data-inspector-action="select-reference" data-inspector-payload="' + ref.id + '">' +
        '<span>reference ' + (i + 1) + '</span><span>' + this.formatReferenceDistance(ref.lengthMm || 0, this.getReferenceUnitSystem(ref)) + '</span>' +
        '</button>'
      );
    }
    html.push('</div>');
    return html.join('');
  };

  ScaleBarBuilder.prototype.buildFontOptionsMarkup = function (selectedFont) {
    return FONT_OPTIONS.map(function (font) {
      return '<option value="' + font + '"' + (selectedFont === font ? ' selected' : '') + '>' + font + '</option>';
    }).join('');
  };

  ScaleBarBuilder.prototype.buildReferenceStyleOptionsMarkup = function (selectedStyle, compact) {
    var labels = compact
      ? { checker: 'Checker', 'checker-invert': 'Invert', 'segmented-dashed': 'Segmented Dashed', 'segmented-ticks': 'Segmented Ticks', 'segmented-blocks': 'Segmented Blocks' }
      : { checker: 'Checker', 'checker-invert': 'Checker Invert', 'segmented-dashed': 'Segmented Dashed', 'segmented-ticks': 'Segmented Ticks', 'segmented-blocks': 'Segmented Blocks' };
    var styles = ['checker', 'checker-invert', 'segmented-dashed', 'segmented-ticks', 'segmented-blocks'];
    var out = [];
    for (var i = 0; i < styles.length; i += 1) {
      var style = styles[i];
      out.push('<option value="' + style + '"' + (selectedStyle === style ? ' selected' : '') + '>' + labels[style] + '</option>');
    }
    return out.join('');
  };

  ScaleBarBuilder.prototype.buildReferenceUnitOptionsMarkup = function (selectedUnit, compact) {
    var unit = String(selectedUnit || '').toLowerCase() === 'imperial' ? 'imperial' : 'metric';
    var metricLabel = compact ? 'Metric' : 'Metric (cm)';
    var imperialLabel = compact ? 'Imperial' : 'Imperial (in)';
    return [
      '<option value="metric"' + (unit === 'metric' ? ' selected' : '') + '>' + metricLabel + '</option>',
      '<option value="imperial"' + (unit === 'imperial' ? ' selected' : '') + '>' + imperialLabel + '</option>'
    ].join('');
  };

  ScaleBarBuilder.prototype.renderInspector = function () {
    var layerList = '';
    var referenceList = '';

    if (!this.state.selectedEntity) {
      this.controls.inspector.innerHTML = referenceList + layerList + '<div class="sbb-note">Select a tag, reference, or overlay object to edit.</div>';
      return;
    }

    var html = '';

    if (this.state.selectedEntity.type === 'tag') {
      var idx = this.state.selectedEntity.id;
      var tag = this.state.tags[idx];
      var tagIdBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
      if (!tag) {
        this.controls.inspector.innerHTML = '<div class="sbb-note">No tag selected.</div>';
        return;
      }

      html = [
        referenceList,
        layerList,
        '<div class="sbb-inspector-title">Tag ' + (idx + 1) + '</div>',
        '<div class="sbb-inspector-code">' + this.getTagDisplayCode(tag.id) + '</div>',
        '<div class="sbb-grid2">',
        '  <div class="sbb-field"><label>X</label><input data-inspector-field="x" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(tag.xMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Y</label><input data-inspector-field="y" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(tag.yMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>ID</label><input data-inspector-field="id" type="number" step="1" min="' + tagIdBounds.min + '" max="' + tagIdBounds.max + '" value="' + tag.id + '" /></div>',
        '</div>',
        '<div class="sbb-actions small">',
        '  <button type="button" class="sbb-button small" data-inspector-action="tag-prev">Prev ID</button>',
        '  <button type="button" class="sbb-button small" data-inspector-action="tag-next">Next ID</button>',
        '  <button type="button" class="sbb-button small" data-inspector-action="tag-toggle-relative">' + (this.state.showRelativeCoordinates ? 'Hide Relative XYZ' : 'Show Relative XYZ') + '</button>',
        '  <button type="button" class="sbb-button small" data-inspector-action="tag-delete">Delete Tag</button>',
        '</div>'
      ].join('');

      this.controls.inspector.innerHTML = html;
      return;
    }

    if (this.state.selectedEntity.type === 'reference') {
      var ref = this.getReferenceById(this.state.selectedEntity.id);
      if (!ref) {
        this.controls.inspector.innerHTML = referenceList + layerList + '<div class="sbb-note">Selected reference no longer exists.</div>';
        return;
      }
      var showRowsField = this.isReferenceRowStyle(ref.style);
      var rowsFieldMarkup = showRowsField
        ? '  <div class="sbb-field"><label>Rows</label><input data-inspector-field="rows" type="number" min="1" max="32" step="1" value="' + Math.max(1, Math.round(ref.rows || 1)) + '" /></div>'
        : '';

      html = [
        referenceList,
        layerList,
        '<div class="sbb-inspector-title">Reference</div>',
        '<div class="sbb-grid2">',
        '  <div class="sbb-field"><label>X</label><input data-inspector-field="x" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.xMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Y</label><input data-inspector-field="y" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.yMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Length</label><input data-inspector-field="length" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.lengthMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Unit Width</label><input data-inspector-field="cellWidth" type="number" min="0.1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.cellWidthMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Unit Height</label><input data-inspector-field="cellHeight" type="number" min="0.1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.cellHeightMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        rowsFieldMarkup,
        '  <div class="sbb-field"><label>Rotation</label><input data-inspector-field="rotation" type="number" step="15" value="' + this.normalizeRotation(ref.rotationDeg || 0) + '" /></div>',
        '  <div class="sbb-field"><label>Style</label><select data-inspector-field="style">' + this.buildReferenceStyleOptionsMarkup(ref.style, false) + '</select></div>',
        '  <div class="sbb-field"><label>Units</label><select data-inspector-field="unitSystem">' + this.buildReferenceUnitOptionsMarkup(ref.unitSystem, false) + '</select></div>',
        '  <div class="sbb-field"><label>Color A</label><input data-inspector-field="colorA" type="color" value="' + (ref.colorA || '#000000') + '" /></div>',
        '  <div class="sbb-field"><label>Color B</label><input data-inspector-field="colorB" type="color" value="' + (ref.colorB || '#ffffff') + '" /></div>',
        '</div>',
        '<label class="sbb-toggle"><input data-inspector-field="showLabel" type="checkbox"' + (ref.showLabel !== false ? ' checked' : '') + ' /> Show label</label>',
        '<label class="sbb-toggle"><input data-inspector-field="showScaleNumbers" type="checkbox"' + (ref.showScaleNumbers ? ' checked' : '') + ' /> Show ruler numbers</label>',
        '<label class="sbb-toggle"><input data-inspector-field="showUnitLabelInside" type="checkbox"' + (ref.showUnitLabelInside ? ' checked' : '') + ' /> Unit label inside bar</label>',
        '<div class="sbb-actions small">',
        '  <button type="button" class="sbb-button small" data-inspector-action="delete-reference" data-inspector-payload="' + ref.id + '">Delete Reference</button>',
        '</div>'
      ].join('');
      this.controls.inspector.innerHTML = html;
      return;
    }

    if (this.state.selectedEntity.type === 'distance') {
      var edge = this.parseDistanceEdgeKey(this.state.selectedEntity.id);
      if (!edge || !this.state.tags[edge.a] || !this.state.tags[edge.b]) {
        this.controls.inspector.innerHTML = referenceList + layerList + '<div class="sbb-note">Selected distance no longer exists.</div>';
        return;
      }
      var tA = this.state.tags[edge.a];
      var tB = this.state.tags[edge.b];
      var dDx = tB.xMm - tA.xMm;
      var dDy = tB.yMm - tA.yMm;
      var dLen = Math.sqrt(dDx * dDx + dDy * dDy);
      var ann = this.getDistanceAnnotation(this.state.selectedEntity.id);
      html = [
        referenceList,
        layerList,
        '<div class="sbb-inspector-title">Distance Annotation</div>',
        '<div class="sbb-note">Tag ' + (edge.a + 1) + ' <-> Tag ' + (edge.b + 1) + '</div>',
        '<div class="sbb-note">Distance: ' + this.formatDistanceMm(dLen) + '</div>',
        '<div class="sbb-note">Anchor: ' + toFixedTrim(ann.t * 100, 1) + '% along pair, offset ' + this.formatSignedDistanceMm(ann.normalOffsetMm) + '</div>',
        '<div class="sbb-note">Descriptor: ' + (ann.hidden ? 'Hidden (muted)' : 'Shown') + '</div>',
        '<div class="sbb-actions small">',
        '  <button type="button" class="sbb-button small" data-inspector-action="distance-toggle">' + (ann.hidden ? 'Show Descriptor' : 'Hide Descriptor') + '</button>',
        '  <button type="button" class="sbb-button small" data-inspector-action="distance-reset">Reset to Center</button>',
        '</div>'
      ].join('');
      this.controls.inspector.innerHTML = html;
      return;
    }

    if (this.state.selectedEntity.type === 'cut') {
      var cutInsets = this.sanitizeCutInsets(this.state.cutInsetsMm);
      this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
      var cutModeCurrent = this.sanitizeCutShapeMode(this.state.cutShapeMode);
      var circleNote = cutModeCurrent === 'circle'
        ? '<div class="sbb-note">Circle diameter: ' + this.formatDistanceMm(this.state.cutCircle.diameterMm) + '</div>'
        : '';
      html = [
        referenceList,
        layerList,
        '<div class="sbb-inspector-title">Cut Outline</div>',
        '<div class="sbb-note">Shape: ' + cutModeCurrent + '</div>',
        '<div class="sbb-note">Edit Mode: ' + (this.state.cutEditMode || 'auto') + '</div>',
        '<div class="sbb-note">Move: ' + (this.state.cutMoveUnlocked ? 'Unlocked' : 'Locked') + ' (use lock icon on outline)</div>',
        '<div class="sbb-note">Insets (mm): L ' + toFixedTrim(cutInsets.left, 1) + ' / R ' + toFixedTrim(cutInsets.right, 1) + ' / T ' + toFixedTrim(cutInsets.top, 1) + ' / B ' + toFixedTrim(cutInsets.bottom, 1) + '</div>',
        circleNote
      ].join('');
      this.controls.inspector.innerHTML = html;
      return;
    }

    if (this.state.selectedEntity.type === 'noise') {
      this.controls.inspector.innerHTML = referenceList + layerList + '<div class="sbb-note">Noise settings are available in the selection shelf.</div>';
      return;
    }
    if (this.state.selectedEntity.type === 'home') {
      var home = this.getHomePoint();
      this.controls.inspector.innerHTML = referenceList + layerList + '<div class="sbb-note">HOME origin at x=' + this.formatCoordinate(home.xMm, 'metric', { minDp: 4, maxDp: 8 }) + ' mm, y=' + this.formatCoordinate(home.yMm, 'metric', { minDp: 4, maxDp: 8 }) + ' mm.</div>';
      return;
    }

    var overlay = this.findOverlayById(this.state.selectedEntity.id);
    if (!overlay) {
      this.controls.inspector.innerHTML = '<div class="sbb-note">Selected overlay no longer exists.</div>';
      return;
    }

    html = [
      referenceList,
      layerList,
      '<div class="sbb-inspector-title">Overlay: ' + overlay.type + '</div>',
      '<div class="sbb-grid2">',
      '  <div class="sbb-field"><label>X</label><input data-inspector-field="x" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(overlay.xMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
      '  <div class="sbb-field"><label>Y</label><input data-inspector-field="y" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(overlay.yMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
      '</div>'
    ].join('');

    if (overlay.type !== 'info') {
      html += [
        '<div class="sbb-grid2">',
        '  <div class="sbb-field"><label>Width</label><input data-inspector-field="w" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(overlay.wMm || 10), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Height</label><input data-inspector-field="h" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(overlay.hMm || 10), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Opacity</label><input data-inspector-field="opacity" type="number" min="0" max="1" step="0.05" value="' + toFixedTrim(clamp(overlay.opacity, 0, 1), 2) + '" /></div>',
        '  <div class="sbb-field"><label>Rotation</label><input data-inspector-field="rotation" type="number" step="15" value="' + this.normalizeRotation(overlay.rotationDeg || 0) + '" /></div>',
        '</div>'
      ].join('');
    }

    if (overlay.type === 'text') {
      html += [
        '<div class="sbb-field"><label>Text</label><textarea data-inspector-field="text">' + (overlay.text || '') + '</textarea></div>',
        '<div class="sbb-grid2">',
        '  <div class="sbb-field"><label>Font</label><select data-inspector-field="fontFamily">' + this.buildFontOptionsMarkup(overlay.fontFamily) + '</select></div>',
        '  <div class="sbb-field"><label>Font Size (pt)</label><input data-inspector-field="fontSize" type="number" min="4" step="0.5" value="' + this.formatUiNumber(this.getOverlayFontSizePt(overlay), 1) + '" /></div>',
        '  <div class="sbb-field"><label>Color</label><input data-inspector-field="color" type="color" value="' + (overlay.color || '#000000') + '" /></div>',
        '  <div class="sbb-field"><label>Align</label><select data-inspector-field="align"><option value="left"' + (overlay.align === 'left' ? ' selected' : '') + '>Left</option><option value="center"' + (overlay.align === 'center' ? ' selected' : '') + '>Center</option><option value="right"' + (overlay.align === 'right' ? ' selected' : '') + '>Right</option></select></div>',
        '</div>'
      ].join('');
    }

    if (overlay.type === 'shape') {
      var armWidthPercent = clamp(parseNumber(overlay.armRatio, 0.24), 0.12, 0.8) * 100;
      var showShapeCoordinatesControl = this.isCircularShapeKind(overlay.shapeKind)
        ? '<label class="sbb-toggle"><input data-inspector-field="showCoordinates" type="checkbox"' + (overlay.showCoordinates ? ' checked' : '') + ' /> Display Coordinates</label>'
        : '';
      html += [
        '<div class="sbb-grid2">',
        '  <div class="sbb-field"><label>Shape</label><select data-inspector-field="shapeKind">' + SHAPE_TYPES.map(function (shapeType) { return '<option value="' + shapeType.value + '"' + (overlay.shapeKind === shapeType.value ? ' selected' : '') + '>' + shapeType.label + '</option>'; }).join('') + '</select></div>',
        '  <div class="sbb-field"><label>Fill</label><input data-inspector-field="fillColor" type="color" value="' + (overlay.fillColor || '#000000') + '" /></div>',
        '  <div class="sbb-field"><label>Stroke</label><input data-inspector-field="strokeColor" type="color" value="' + (overlay.strokeColor || '#000000') + '" /></div>',
        '  <div class="sbb-field"><label>Stroke W</label><input data-inspector-field="strokeWidth" type="number" min="0" step="0.1" value="' + this.formatUiNumber(this.mmToUi(parseNumber(overlay.strokeWidthMm, 0.4)), this.state.unitSystem === 'imperial' ? 3 : 1) + '" /></div>',
        '  <div class="sbb-field"><label>Cross Arm (%)</label><input data-inspector-field="armRatio" type="number" min="12" max="80" step="1" value="' + this.formatUiNumber(armWidthPercent, 0) + '" /></div>',
        '  <div class="sbb-field"><label>Rows</label><input data-inspector-field="rows" type="number" min="1" max="32" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.rows, 4))) + '" /></div>',
        '  <div class="sbb-field"><label>Cols</label><input data-inspector-field="cols" type="number" min="1" max="32" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.cols, 4))) + '" /></div>',
        '  <div class="sbb-field"><label>Rings</label><input data-inspector-field="ringCount" type="number" min="1" max="20" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.ringCount, 3))) + '" /></div>',
        '  <div class="sbb-field"><label>Spokes</label><input data-inspector-field="spokeCount" type="number" min="1" max="64" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.spokeCount, 8))) + '" /></div>',
        '</div>'
      ].join('');
      html += showShapeCoordinatesControl;
    }

    html += [
      '<div class="sbb-grid2">',
      '  <label class="sbb-toggle"><input data-inspector-field="visible" type="checkbox"' + (overlay.visible ? ' checked' : '') + ' /> Visible</label>',
      '  <label class="sbb-toggle"><input data-inspector-field="locked" type="checkbox"' + (overlay.locked ? ' checked' : '') + ' /> Locked</label>',
      '</div>',
      '<div class="sbb-actions small">',
      '  <button type="button" class="sbb-button small" data-inspector-action="raise">Bring Forward</button>',
      '  <button type="button" class="sbb-button small" data-inspector-action="lower">Send Backward</button>',
      (overlay.type === 'info' || overlay.type === 'logo') ? '' : '  <button type="button" class="sbb-button small" data-inspector-action="delete">Delete</button>',
      '</div>'
    ].join('');

    this.controls.inspector.innerHTML = html;
  };

  ScaleBarBuilder.prototype.getSelectedOverlay = function () {
    if (!this.state.selectedEntity || this.state.selectedEntity.type !== 'overlay') {
      return null;
    }
    return this.findOverlayById(this.state.selectedEntity.id);
  };

  ScaleBarBuilder.prototype.handleSelectionShelfEvent = function (event) {
    var target = event.target;
    if (!target || !target.dataset) {
      return;
    }
    if (this.isDeferredNumericInputEvent(event, target)) {
      return;
    }
    var field = target.dataset.shelfField;
    var action = target.dataset.shelfAction;
    var paper = this.getPaper();

    if (action) {
      if (action === 'start-inline-edit') {
        var selectedOverlay = this.getSelectedOverlay();
        if (selectedOverlay && selectedOverlay.type === 'text') {
          this.startInlineTextEditing(selectedOverlay.id);
        }
      } else if (action === 'toggle-info-overlay') {
        if (this.toggleInfoOverlayDimmed()) {
          this.setStatus(this.isInfoOverlayDimmed() ? 'Overlay info hidden.' : 'Overlay info shown.', false);
          this.render();
        }
      } else if (action === 'tag-toggle-relative') {
        this.state.showRelativeCoordinates = !this.state.showRelativeCoordinates;
        this.render();
      } else if (action === 'tag-delete' && this.state.selectedEntity && this.state.selectedEntity.type === 'tag') {
        this.deleteTagAtIndex(this.state.selectedEntity.id);
      } else if (action === 'tag-apply-size-all' && this.state.selectedEntity && this.state.selectedEntity.type === 'tag') {
        var selectedSize = this.getTagSizeMm(this.state.selectedEntity.id);
        this.ensureTagSizes();
        var printableAll = this.getPrintableRect(paper, selectedSize / 2);
        for (var tsi = 0; tsi < this.state.tagCount; tsi += 1) {
          this.state.tagSizesMm[tsi] = selectedSize;
          this.state.tags[tsi].xMm = clamp(this.state.tags[tsi].xMm, printableAll.minX, printableAll.maxX);
          this.state.tags[tsi].yMm = clamp(this.state.tags[tsi].yMm, printableAll.minY, printableAll.maxY);
        }
        this.state.tagSizeMm = selectedSize;
        this.controls.tagSize.value = this.formatUiNumber(this.mmToUi(selectedSize), this.state.unitSystem === 'imperial' ? 3 : 1);
        this.render();
      } else if (action === 'distance-reset' && this.state.selectedEntity && this.state.selectedEntity.type === 'distance') {
        var selectedDistanceKey = this.state.selectedEntity.id;
        var selectedDistanceAnn = this.getDistanceAnnotation(selectedDistanceKey);
        this.state.distanceAnnotations[selectedDistanceKey] = { t: 0.5, normalOffsetMm: 0, hidden: !!selectedDistanceAnn.hidden };
        this.render();
      } else if (action === 'distance-toggle' && this.state.selectedEntity && this.state.selectedEntity.type === 'distance') {
        var shelfDistanceKey = this.state.selectedEntity.id;
        var shelfDistanceAnn = this.getDistanceAnnotation(shelfDistanceKey);
        shelfDistanceAnn.hidden = !shelfDistanceAnn.hidden;
        this.state.distanceAnnotations[shelfDistanceKey] = shelfDistanceAnn;
        this.render();
      } else if (action === 'cut-reset' && this.state.selectedEntity && this.state.selectedEntity.type === 'cut') {
        this.state.cutInsetsMm = { left: 0, right: 0, top: 0, bottom: 0 };
        this.state.cutEditMode = 'auto';
        this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
        this.state.cutCircle.initialized = false;
        this.render();
      } else if (action === 'cut-manual-tool-draw' && this.state.selectedEntity && this.state.selectedEntity.type === 'cut') {
        this.state.cutShapeMode = 'manual';
        var drawManual = this.getCutManualState();
        drawManual.tool = 'draw';
        this.state.cutManual = drawManual;
        this.state.cutEditMode = 'manual';
        this.render();
      } else if (action === 'cut-manual-tool-edit' && this.state.selectedEntity && this.state.selectedEntity.type === 'cut') {
        this.state.cutShapeMode = 'manual';
        var editManual = this.getCutManualState();
        editManual.tool = 'edit';
        this.state.cutManual = editManual;
        this.manualCutPreviewPointerMm = null;
        this.state.cutEditMode = 'manual';
        this.render();
      } else if (action === 'cut-manual-clear' && this.state.selectedEntity && this.state.selectedEntity.type === 'cut') {
        this.state.cutShapeMode = 'manual';
        this.resetCutManual();
        this.state.cutEditMode = 'manual';
        this.render();
      } else if (action === 'cut-manual-point-straight' && this.state.selectedEntity && this.state.selectedEntity.type === 'cut') {
        var pointToStraight = this.getCutManualState();
        if (this.convertCutManualPointToStraight(pointToStraight.selectedPointIndex)) {
          this.state.cutEditMode = 'manual';
          this.render();
        }
      } else if (action === 'cut-manual-point-bezier' && this.state.selectedEntity && this.state.selectedEntity.type === 'cut') {
        var pointToBezier = this.getCutManualState();
        if (this.convertCutManualPointToBezier(pointToBezier.selectedPointIndex)) {
          this.state.cutEditMode = 'manual';
          this.render();
        }
      } else if (action === 'align-left' || action === 'align-center' || action === 'align-right') {
        var alignOverlay = this.getSelectedOverlay();
        if (alignOverlay && alignOverlay.type === 'text') {
          alignOverlay.align = action.replace('align-', '');
          this.render();
        }
      } else if (action === 'noise-settings') {
        this.state.selectedEntity = { type: 'noise', id: 'background-noise' };
        this.render();
      }
      return;
    }

    if (field === 'showMeasurements') {
      this.state.showReferenceMeasurements = !!target.checked;
      this.render();
      return;
    }

    if (!field || !this.state.selectedEntity) {
      return;
    }

    if (this.state.selectedEntity.type === 'noise') {
      this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
      if (field === 'noiseEnabled') {
        this.state.backgroundNoise.enabled = !!target.checked;
      } else if (field === 'noiseGrainSize') {
        this.state.backgroundNoise.grainSizeMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(this.state.backgroundNoise.grainSizeMm))), 0.2, 8);
      } else if (field === 'noiseContrast') {
        this.state.backgroundNoise.contrast = clamp(parseNumber(target.value, this.state.backgroundNoise.contrast), 0, 1);
      } else if (field === 'noiseColorA') {
        this.state.backgroundNoise.colorA = target.value || DEFAULT_NOISE_COLOR_A;
      } else if (field === 'noiseColorB') {
        this.state.backgroundNoise.colorB = target.value || DEFAULT_NOISE_COLOR_B;
      }
      this.noiseTextureCache = null;
      this.render();
      return;
    }

    if (this.state.selectedEntity.type === 'overlay') {
      var overlay = this.getSelectedOverlay();
      if (!overlay) {
        return;
      }
      if (field === 'fontFamily') {
        overlay.fontFamily = target.value || this.state.defaultFontFamily;
      } else if (field === 'fontSize') {
        overlay.fontSizePt = clamp(parseNumber(target.value, this.getOverlayFontSizePt(overlay)), 4, 144);
      } else if (field === 'color') {
        overlay.color = target.value || '#000000';
      } else if (field === 'rotation') {
        overlay.rotationDeg = this.snapRotation15(parseNumber(target.value, overlay.rotationDeg || 0));
      } else if (field === 'w') {
        overlay.wMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(overlay.wMm || 10))), 2, 600);
      } else if (field === 'h') {
        overlay.hMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(overlay.hMm || 10))), 0.2, 600);
      } else if (field === 'shapeKind') {
        overlay.shapeKind = target.value || 'rectangle';
      } else if (field === 'fillColor') {
        overlay.fillColor = target.value || '#000000';
      } else if (field === 'strokeColor') {
        overlay.strokeColor = target.value || '#000000';
      } else if (field === 'strokeWidth') {
        overlay.strokeWidthMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(parseNumber(overlay.strokeWidthMm, 0.4)))), 0, 20);
      } else if (field === 'opacity') {
        overlay.opacity = clamp(parseNumber(target.value, overlay.opacity || 1), 0, 1);
      } else if (field === 'rows') {
        overlay.rows = clamp(Math.round(parseNumber(target.value, overlay.rows || 4)), 1, 32);
      } else if (field === 'cols') {
        overlay.cols = clamp(Math.round(parseNumber(target.value, overlay.cols || 4)), 1, 32);
      } else if (field === 'ringCount') {
        overlay.ringCount = clamp(Math.round(parseNumber(target.value, overlay.ringCount || 3)), 1, 20);
      } else if (field === 'spokeCount') {
        overlay.spokeCount = clamp(Math.round(parseNumber(target.value, overlay.spokeCount || 8)), 1, 64);
      } else if (field === 'armRatio') {
        overlay.armRatio = clamp(parseNumber(target.value, clamp(parseNumber(overlay.armRatio, 0.24), 0.12, 0.8) * 100) / 100, 0.12, 0.8);
      } else if (field === 'showCoordinates') {
        overlay.showCoordinates = !!target.checked;
      }
      this.clampOverlayToPrintable(overlay, paper);
      this.render();
      return;
    }

    if (this.state.selectedEntity.type === 'tag') {
      var tagIdx = this.state.selectedEntity.id;
      if (!this.state.tags[tagIdx]) {
        return;
      }
      if (field === 'tagSize') {
        var nextTagSize = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(this.getTagSizeMm(tagIdx)))), 8, 180);
        this.ensureTagSizes();
        this.state.tagSizesMm[tagIdx] = nextTagSize;
        this.state.tagSizeMm = nextTagSize;
        var printableTag = this.getPrintableRect(paper, nextTagSize / 2);
        this.state.tags[tagIdx].xMm = clamp(this.state.tags[tagIdx].xMm, printableTag.minX, printableTag.maxX);
        this.state.tags[tagIdx].yMm = clamp(this.state.tags[tagIdx].yMm, printableTag.minY, printableTag.maxY);
        this.controls.tagSize.value = this.formatUiNumber(this.mmToUi(nextTagSize), this.state.unitSystem === 'imperial' ? 3 : 1);
      } else if (field === 'tagId') {
        var currentSelectedTagId = this.state.tags[tagIdx].id;
        var tagIdBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
        var requestedSelectedTagId = Math.round(parseNumber(target.value, currentSelectedTagId));
        var parsedSelectedTagId = clamp(Math.round(parseNumber(target.value, currentSelectedTagId)), tagIdBounds.min, tagIdBounds.max);
        var usedSelectedIds = {};
        var reservedSelectedIds = this.getReservedTagIdMapForCurrentScope();
        for (var tsi = 0; tsi < this.state.tagCount; tsi += 1) {
          if (tsi === tagIdx || !this.state.tags[tsi]) {
            continue;
          }
          usedSelectedIds[this.state.tags[tsi].id] = true;
        }
        if (requestedSelectedTagId < tagIdBounds.min && currentSelectedTagId <= tagIdBounds.min) {
          this.state.tags[tagIdx].id = tagIdBounds.min;
          this.syncDynamicRows();
          this.render();
          return;
        }
        if (requestedSelectedTagId > tagIdBounds.max && currentSelectedTagId >= tagIdBounds.max) {
          this.state.tags[tagIdx].id = tagIdBounds.max;
          this.syncDynamicRows();
          this.render();
          return;
        }
        if (parsedSelectedTagId === currentSelectedTagId + 1) {
          this.state.tags[tagIdx].id = this.findNextUniqueViableTagId(currentSelectedTagId + 1, usedSelectedIds, reservedSelectedIds);
        } else if (parsedSelectedTagId === currentSelectedTagId - 1) {
          this.state.tags[tagIdx].id = this.findPrevUniqueViableTagId(currentSelectedTagId, usedSelectedIds, reservedSelectedIds);
        } else {
          this.state.tags[tagIdx].id = this.findNextUniqueViableTagId(parsedSelectedTagId, usedSelectedIds, reservedSelectedIds);
        }
        this.resolveUniqueViableTagIds();
        this.syncDynamicRows();
      }
      this.render();
      return;
    }

    if (this.state.selectedEntity.type === 'cut') {
      if (field === 'cutShapeMode') {
        this.state.cutShapeMode = this.sanitizeCutShapeMode(target.value);
        if (this.state.cutShapeMode === 'circle') {
          this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
          this.state.cutCircle.initialized = false;
          this.state.cutInsetsMm = { left: 0, right: 0, top: 0, bottom: 0 };
        } else if (this.state.cutShapeMode === 'manual') {
          this.state.cutManual = this.sanitizeCutManual(this.state.cutManual);
        } else {
          this.manualCutPreviewPointerMm = null;
        }
        this.state.cutEditMode = 'manual';
        this.state.selectedEntity = { type: 'cut', id: 'cut-shape' };
        this.render();
      } else if (field === 'cutCircleDiameter') {
        this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
        var circleDiameterMm = this.uiToMm(parseNumber(target.value, this.mmToUi(this.state.cutCircle.diameterMm)));
        this.state.cutCircle.diameterMm = clamp(circleDiameterMm, 5, Math.max(this.getPaper().width, this.getPaper().height) * 2);
        this.state.cutCircle.initialized = true;
        this.state.cutEditMode = 'manual';
        this.render();
      } else if (field === 'cutManualGrid') {
        this.state.cutShapeMode = 'manual';
        var gridManual = this.getCutManualState();
        gridManual.showGrid = !!target.checked;
        this.state.cutManual = gridManual;
        this.state.cutEditMode = 'manual';
        this.render();
      }
      return;
    }

    if (this.state.selectedEntity.type === 'reference') {
      var ref = this.getReferenceById(this.state.selectedEntity.id);
      if (!ref) {
        return;
      }
      var printableRef = this.getPrintableRect(paper, 0);
      var printableRefWidth = Math.max(0.2, printableRef.maxX - printableRef.minX);
      var printableRefHeight = Math.max(0.2, printableRef.maxY - printableRef.minY);
      if (field === 'cellWidth') {
        ref.cellWidthMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(ref.cellWidthMm))), 0.2, printableRefWidth);
        var cellCount = Math.max(1, Math.round(ref.lengthMm / ref.cellWidthMm));
        ref.lengthMm = clamp(cellCount * ref.cellWidthMm, ref.cellWidthMm, printableRefWidth);
      } else if (field === 'cellHeight') {
        var currentRows = Math.max(1, Math.round(ref.rows || 1));
        var maxCellHeight = Math.max(0.2, printableRefHeight / currentRows);
        ref.cellHeightMm = clamp(this.uiToMm(parseNumber(target.value, this.mmToUi(ref.cellHeightMm))), 0.2, maxCellHeight);
      } else if (field === 'rows') {
        var maxRowsAllowed = Math.max(1, Math.floor(printableRefHeight / Math.max(0.2, ref.cellHeightMm)));
        ref.rows = clamp(Math.round(parseNumber(target.value, ref.rows || 1)), 1, Math.min(32, maxRowsAllowed));
      } else if (field === 'length') {
        var newLen = this.uiToMm(parseNumber(target.value, this.mmToUi(ref.lengthMm)));
        var unit = Math.max(0.2, ref.cellWidthMm);
        ref.lengthMm = clamp(Math.round(newLen / unit) * unit, unit, printableRefWidth);
      } else if (field === 'style') {
        ref.style = target.value || 'checker';
        if (!this.isReferenceRowStyle(ref.style)) {
          ref.rows = 1;
        }
      } else if (field === 'unitSystem') {
        var nextUnit = String(target.value || '').toLowerCase() === 'imperial' ? 'imperial' : 'metric';
        if (ref.unitSystem !== nextUnit) {
          var prevCellW = Math.max(0.2, ref.cellWidthMm);
          var prevCells = Math.max(1, Math.round(ref.lengthMm / prevCellW));
          var unitCellW = nextUnit === 'imperial' ? MM_PER_IN : MM_PER_CM;
          var unitCellH = nextUnit === 'imperial' ? (MM_PER_IN / 4) : 5;
          ref.unitSystem = nextUnit;
          ref.cellWidthMm = clamp(unitCellW, 0.2, printableRefWidth);
          ref.cellHeightMm = clamp(unitCellH, 0.2, printableRefHeight / Math.max(1, ref.rows || 1));
          ref.lengthMm = clamp(ref.cellWidthMm * prevCells, ref.cellWidthMm, printableRefWidth);
        }
      } else if (field === 'rotation') {
        ref.rotationDeg = this.snapRotation15(parseNumber(target.value, ref.rotationDeg || 0));
      } else if (field === 'showScaleNumbers') {
        ref.showScaleNumbers = !!target.checked;
      } else if (field === 'showUnitLabelInside') {
        ref.showUnitLabelInside = !!target.checked;
      }
      this.clampReferenceToPrintable(ref, paper);
      this.render();
    }
  };

  ScaleBarBuilder.prototype.getSelectionShelfOverlayMarkup = function (overlay) {
    if (!overlay) {
      return '<div class="sbb-shelf-note">No selection.</div>';
    }
    if (overlay.type === 'info') {
      return [
        '<div class="sbb-shelf-row">',
        '  <span class="sbb-shelf-note">Overlay info widget selected.</span>',
        '  <button type="button" class="sbb-button small sbb-info-toggle' + (this.isInfoOverlayDimmed() ? '' : ' active') + '" data-shelf-action="toggle-info-overlay">' + (this.isInfoOverlayDimmed() ? 'Show Info' : 'Hide Info') + '</button>',
        '</div>'
      ].join('');
    }
    if (overlay.type === 'text') {
      return [
        '<div class="sbb-shelf-row">',
        '  <button type="button" class="sbb-button small" data-shelf-action="start-inline-edit">Inline Edit</button>',
        '  <button type="button" class="sbb-button small" data-shelf-action="align-left">Left</button>',
        '  <button type="button" class="sbb-button small" data-shelf-action="align-center">Center</button>',
        '  <button type="button" class="sbb-button small" data-shelf-action="align-right">Right</button>',
        '  <label>Font</label>',
        '  <select data-shelf-field="fontFamily">' + this.buildFontOptionsMarkup(overlay.fontFamily) + '</select>',
        '  <label>Size (pt)</label>',
        '  <input data-shelf-field="fontSize" type="number" min="4" step="0.5" value="' + this.formatUiNumber(this.getOverlayFontSizePt(overlay), 1) + '" />',
        '  <label>Color</label>',
        '  <input data-shelf-field="color" type="color" value="' + (overlay.color || '#000000') + '" />',
        '  <label>Rotate</label>',
        '  <input data-shelf-field="rotation" type="number" step="15" value="' + this.normalizeRotation(overlay.rotationDeg || 0) + '" />',
        '</div>'
      ].join('');
    }
    if (overlay.type === 'image' || overlay.type === 'logo') {
      return [
        '<div class="sbb-shelf-row">',
        '  <label>Opacity</label>',
        '  <input data-shelf-field="opacity" type="number" min="0" max="1" step="0.05" value="' + toFixedTrim(clamp(overlay.opacity || 1, 0, 1), 2) + '" />',
        '  <label>Rotate</label>',
        '  <input data-shelf-field="rotation" type="number" step="15" value="' + this.normalizeRotation(overlay.rotationDeg || 0) + '" />',
        '</div>'
      ].join('');
    }
    if (overlay.type === 'shape') {
      var crossArmControl = (overlay.shapeKind === 'cross')
        ? [
          '  <label>Arm (%)</label>',
          '  <input data-shelf-field="armRatio" type="number" min="12" max="80" step="1" value="' + this.formatUiNumber(clamp(parseNumber(overlay.armRatio, 0.24), 0.12, 0.8) * 100, 0) + '" />'
        ].join('')
        : '';
      var shapeRowsControls = (overlay.shapeKind === 'grid')
        ? [
          '  <label>Rows</label>',
          '  <input data-shelf-field="rows" type="number" min="1" max="32" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.rows, 4))) + '" />',
          '  <label>Cols</label>',
          '  <input data-shelf-field="cols" type="number" min="1" max="32" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.cols, 4))) + '" />'
        ].join('')
        : '';
      var circleGridControls = (overlay.shapeKind === 'circle-grid')
        ? [
          '  <label>Rings</label>',
          '  <input data-shelf-field="ringCount" type="number" min="1" max="20" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.ringCount, 3))) + '" />',
          '  <label>Spokes</label>',
          '  <input data-shelf-field="spokeCount" type="number" min="1" max="64" step="1" value="' + Math.max(1, Math.round(parseNumber(overlay.spokeCount, 8))) + '" />'
        ].join('')
        : '';
      var circleCoordinateToggle = this.isCircularShapeKind(overlay.shapeKind)
        ? '  <label class="sbb-shelf-toggle">Display Coordinates <input data-shelf-field="showCoordinates" type="checkbox"' + (overlay.showCoordinates ? ' checked' : '') + ' /></label>'
        : '';
      return [
        '<div class="sbb-shelf-row">',
        '  <label>Kind</label>',
        '  <select data-shelf-field="shapeKind">' + SHAPE_TYPES.map(function (shapeType) { return '<option value="' + shapeType.value + '"' + (overlay.shapeKind === shapeType.value ? ' selected' : '') + '>' + shapeType.label + '</option>'; }).join('') + '</select>',
        '  <label>Fill</label>',
        '  <input data-shelf-field="fillColor" type="color" value="' + (overlay.fillColor || '#000000') + '" />',
        '  <label>Stroke</label>',
        '  <input data-shelf-field="strokeColor" type="color" value="' + (overlay.strokeColor || '#000000') + '" />',
        '  <label>Stroke W</label>',
        '  <input data-shelf-field="strokeWidth" type="number" min="0" step="0.1" value="' + this.formatUiNumber(this.mmToUi(parseNumber(overlay.strokeWidthMm, 0.4)), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
        '  <label>Opacity</label>',
        '  <input data-shelf-field="opacity" type="number" min="0" max="1" step="0.05" value="' + toFixedTrim(clamp(overlay.opacity || 1, 0, 1), 2) + '" />',
        '  <label>Rotate</label>',
        '  <input data-shelf-field="rotation" type="number" step="15" value="' + this.normalizeRotation(overlay.rotationDeg || 0) + '" />',
        '  <label>W</label>',
        '  <input data-shelf-field="w" type="number" min="0.1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(overlay.wMm || 10), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
        '  <label>H</label>',
        '  <input data-shelf-field="h" type="number" min="0.1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(overlay.hMm || 10), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
        crossArmControl,
        shapeRowsControls,
        circleGridControls,
        circleCoordinateToggle,
        '</div>'
      ].join('');
    }
    return '<div class="sbb-shelf-note">Overlay selected.</div>';
  };

  ScaleBarBuilder.prototype.getSelectionShelfReferenceMarkup = function (ref) {
    if (!ref) {
      return '<div class="sbb-shelf-note">No selection.</div>';
    }
    var unitLabel = this.state.unitSystem === 'imperial' ? 'in' : 'mm';
    var rowsShelfMarkup = this.isReferenceRowStyle(ref.style)
      ? '  <label>Rows</label>  <input data-shelf-field="rows" type="number" min="1" max="32" step="1" value="' + Math.max(1, Math.round(ref.rows || 1)) + '" />'
      : '';
    return [
      '<div class="sbb-shelf-row">',
      '  <label>Unit W (' + unitLabel + ')</label>',
      '  <input data-shelf-field="cellWidth" type="number" min="0.1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.cellWidthMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
      '  <label>Unit H (' + unitLabel + ')</label>',
      '  <input data-shelf-field="cellHeight" type="number" min="0.1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.cellHeightMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
      rowsShelfMarkup,
      '  <label>Length (' + unitLabel + ')</label>',
      '  <input data-shelf-field="length" type="number" step="0.1" value="' + this.formatUiNumber(this.mmToUi(ref.lengthMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
      '  <label>Style</label>',
      '  <select data-shelf-field="style">' + this.buildReferenceStyleOptionsMarkup(ref.style, true) + '</select>',
      '  <label>Units</label>',
      '  <select data-shelf-field="unitSystem">' + this.buildReferenceUnitOptionsMarkup(ref.unitSystem, true) + '</select>',
      '  <label>Rotate</label>',
      '  <input data-shelf-field="rotation" type="number" step="15" value="' + this.normalizeRotation(ref.rotationDeg || 0) + '" />',
      '  <label class="sbb-shelf-toggle">Ruler Numbers <input data-shelf-field="showScaleNumbers" type="checkbox"' + (ref.showScaleNumbers ? ' checked' : '') + ' /></label>',
      '  <label class="sbb-shelf-toggle">Unit In Bar <input data-shelf-field="showUnitLabelInside" type="checkbox"' + (ref.showUnitLabelInside ? ' checked' : '') + ' /></label>',
      '  <label class="sbb-shelf-toggle">Measurements <input data-shelf-field="showMeasurements" type="checkbox"' + (this.state.showReferenceMeasurements ? ' checked' : '') + ' /></label>',
      '</div>'
    ].join('');
  };

  ScaleBarBuilder.prototype.getSelectionShelfTagMarkup = function (tagIdx, selectedTag) {
    if (!selectedTag) {
      return '<div class="sbb-shelf-note">No selection.</div>';
    }
    var tagIdBounds = this.getCurrentTagIdBounds(this.state.tagType, this.state.tagFamily);
    var safeTagId = clamp(Math.round(parseNumber(selectedTag.id, 0)), tagIdBounds.min, tagIdBounds.max);
    return [
      '<div class="sbb-shelf-row">',
      '  <span class="sbb-shelf-note">Tag ' + (tagIdx + 1) + ': ' + this.getTagDisplayCode(selectedTag.id) + '</span>',
      '  <label>Tag ID</label>',
      '  <input data-shelf-field="tagId" type="number" step="1" min="' + tagIdBounds.min + '" max="' + tagIdBounds.max + '" value="' + safeTagId + '" />',
      '  <label>Size (' + (this.state.unitSystem === 'imperial' ? 'in' : 'mm') + ')</label>',
      '  <input data-shelf-field="tagSize" type="number" min="1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(this.getTagSizeMm(tagIdx)), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
      '  <button type="button" class="sbb-button small" data-shelf-action="tag-apply-size-all">Apply Size to All</button>',
      '  <button type="button" class="sbb-button small" data-shelf-action="tag-toggle-relative">' + (this.state.showRelativeCoordinates ? 'Hide Relative XYZ' : 'Show Relative XYZ') + '</button>',
      '  <button type="button" class="sbb-button small" data-shelf-action="tag-delete">Delete Tag</button>',
      '</div>'
    ].join('');
  };

  ScaleBarBuilder.prototype.getSelectionShelfDistanceMarkup = function (edgeKey) {
    var dEdge = this.parseDistanceEdgeKey(edgeKey);
    if (!dEdge || !this.state.tags[dEdge.a] || !this.state.tags[dEdge.b]) {
      return '<div class="sbb-shelf-note">No selection.</div>';
    }
    var dA = this.state.tags[dEdge.a];
    var dB = this.state.tags[dEdge.b];
    var dDist = Math.sqrt(Math.pow(dB.xMm - dA.xMm, 2) + Math.pow(dB.yMm - dA.yMm, 2));
    var dAnn = this.getDistanceAnnotation(edgeKey);
    return [
      '<div class="sbb-shelf-row">',
      '  <span class="sbb-shelf-note">Distance Tag ' + (dEdge.a + 1) + ' <-> Tag ' + (dEdge.b + 1) + ' = ' + this.formatDistanceMm(dDist) + '</span>',
      '  <button type="button" class="sbb-button small" data-shelf-action="distance-toggle">' + (dAnn.hidden ? 'Show Descriptor' : 'Hide Descriptor') + '</button>',
      '  <button type="button" class="sbb-button small" data-shelf-action="distance-reset">Reset to Center</button>',
      '</div>'
    ].join('');
  };

  ScaleBarBuilder.prototype.getSelectionShelfCutMarkup = function () {
    var insets = this.sanitizeCutInsets(this.state.cutInsetsMm);
    var cutMode = this.sanitizeCutShapeMode(this.state.cutShapeMode);
    var circleControls = '';
    var manualControls = '';
    if (cutMode === 'circle') {
      this.state.cutCircle = this.sanitizeCutCircle(this.state.cutCircle);
      circleControls = '  <label>Diameter (' + (this.state.unitSystem === 'imperial' ? 'in' : 'mm') + ')</label>' +
        '  <input data-shelf-field="cutCircleDiameter" type="number" min="1" step="0.1" value="' + this.formatUiNumber(this.mmToUi(this.state.cutCircle.diameterMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />';
    } else if (cutMode === 'manual') {
      var manual = this.getCutManualState();
      var isDrawTool = manual.tool === 'draw';
      var isEditTool = manual.tool === 'edit';
      var selectedPoint = clamp(parseNumber(manual.selectedPointIndex, -1), -1, Math.max(-1, manual.nodes.length - 1));
      var pointType = selectedPoint >= 0 && manual.nodes[selectedPoint]
        ? (this.isCutManualNodeBezier(manual.nodes[selectedPoint]) ? 'bezier' : 'straight')
        : 'none';
      var pointConvertControls = selectedPoint >= 0
        ? [
          '  <span class="sbb-shelf-note">Point ' + (selectedPoint + 1) + ': ' + pointType + '</span>',
          '  <button type="button" class="sbb-button small' + (pointType === 'straight' ? ' active' : '') + '" data-shelf-action="cut-manual-point-straight">To Straight</button>',
          '  <button type="button" class="sbb-button small' + (pointType === 'bezier' ? ' active' : '') + '" data-shelf-action="cut-manual-point-bezier">To Bezier</button>'
        ].join('')
        : '';
      manualControls = [
        '  <span class="sbb-shelf-note">Manual path: ' + manual.nodes.length + ' points, ' + (manual.closed ? 'closed' : 'open') + '. Click first point to close.</span>',
        '  <button type="button" class="sbb-button small' + (isDrawTool ? ' active' : '') + '" data-shelf-action="cut-manual-tool-draw">Draw</button>',
        '  <button type="button" class="sbb-button small' + (isEditTool ? ' active' : '') + '" data-shelf-action="cut-manual-tool-edit">Edit</button>',
        '  <button type="button" class="sbb-button small" data-shelf-action="cut-manual-clear">Clear</button>',
        '  <label class="sbb-shelf-toggle">Grid <input data-shelf-field="cutManualGrid" type="checkbox"' + (manual.showGrid ? ' checked' : '') + ' /></label>',
        pointConvertControls
      ].join('');
    }
    return [
      '<div class="sbb-shelf-row">',
      '  <span class="sbb-shelf-note">Cut shape selected (' + (this.state.cutMoveUnlocked ? 'Move unlocked' : 'Move locked') + '). Insets L/R/T/B: ' + toFixedTrim(insets.left, 1) + '/' + toFixedTrim(insets.right, 1) + '/' + toFixedTrim(insets.top, 1) + '/' + toFixedTrim(insets.bottom, 1) + ' mm</span>',
      '  <label>Shape</label>',
      '  <select data-shelf-field="cutShapeMode"><option value="rectangle"' + (cutMode === 'rectangle' ? ' selected' : '') + '>Rectangle</option><option value="conform"' + (cutMode === 'conform' ? ' selected' : '') + '>Conform</option><option value="angled"' + (cutMode === 'angled' ? ' selected' : '') + '>Angled</option><option value="circle"' + (cutMode === 'circle' ? ' selected' : '') + '>Circle</option><option value="manual"' + (cutMode === 'manual' ? ' selected' : '') + '>Manual Cut Lines</option></select>',
      circleControls,
      manualControls,
      '  <button type="button" class="sbb-button small" data-shelf-action="cut-reset">Reset Cut Insets</button>',
      '</div>'
    ].join('');
  };

  ScaleBarBuilder.prototype.getSelectionShelfNoiseMarkup = function () {
    this.state.backgroundNoise = this.sanitizeBackgroundNoise(this.state.backgroundNoise);
    var noise = this.state.backgroundNoise;
    var unitLabel = this.state.unitSystem === 'imperial' ? 'in' : 'mm';
    return [
      '<div class="sbb-shelf-row">',
      '  <span class="sbb-shelf-note">Background noise settings</span>',
      '  <label class="sbb-shelf-toggle">Enabled <input data-shelf-field="noiseEnabled" type="checkbox"' + (noise.enabled ? ' checked' : '') + ' /></label>',
      '  <label>Grain (' + unitLabel + ')</label>',
      '  <input data-shelf-field="noiseGrainSize" type="number" min="0.1" max="8" step="0.1" value="' + this.formatUiNumber(this.mmToUi(noise.grainSizeMm), this.state.unitSystem === 'imperial' ? 3 : 1) + '" />',
      '  <label>Contrast</label>',
      '  <input data-shelf-field="noiseContrast" type="number" min="0" max="1" step="0.05" value="' + toFixedTrim(noise.contrast, 2) + '" />',
      '  <label>Color A</label>',
      '  <input data-shelf-field="noiseColorA" type="color" value="' + (noise.colorA || DEFAULT_NOISE_COLOR_A) + '" />',
      '  <label>Color B</label>',
      '  <input data-shelf-field="noiseColorB" type="color" value="' + (noise.colorB || DEFAULT_NOISE_COLOR_B) + '" />',
      '</div>'
    ].join('');
  };

  ScaleBarBuilder.prototype.renderSelectionShelf = function () {
    if (!this.controls.selectionShelf) {
      return;
    }

    if (!this.state.selectedEntity) {
      this.controls.selectionShelf.innerHTML = '<div class="sbb-shelf-note">Select an object to edit quickly.</div>';
      return;
    }

    var html = '';
    if (this.state.selectedEntity.type === 'overlay') {
      html = this.getSelectionShelfOverlayMarkup(this.getSelectedOverlay());
    } else if (this.state.selectedEntity.type === 'reference') {
      html = this.getSelectionShelfReferenceMarkup(this.getReferenceById(this.state.selectedEntity.id));
    } else if (this.state.selectedEntity.type === 'tag') {
      html = this.getSelectionShelfTagMarkup(this.state.selectedEntity.id, this.state.tags[this.state.selectedEntity.id]);
    } else if (this.state.selectedEntity.type === 'distance') {
      html = this.getSelectionShelfDistanceMarkup(this.state.selectedEntity.id);
    } else if (this.state.selectedEntity.type === 'cut') {
      html = this.getSelectionShelfCutMarkup();
    } else if (this.state.selectedEntity.type === 'home') {
      html = '<div class="sbb-shelf-row"><span class="sbb-shelf-note">HOME selected. Drag the crosshair on canvas to move origin.</span></div>';
    } else if (this.state.selectedEntity.type === 'noise') {
      html = this.getSelectionShelfNoiseMarkup();
    } else {
      html = '<div class="sbb-shelf-note">Selection active.</div>';
    }

    this.controls.selectionShelf.innerHTML = html;
  };

  ScaleBarBuilder.prototype.startInlineTextEditing = function (overlayId) {
    var overlay = this.findOverlayById(overlayId);
    if (!overlay || overlay.type !== 'text') {
      return;
    }
    this.inlineTextEditing = overlayId;
    this.controls.inlineTextEditor.value = overlay.text || '';
    this.controls.inlineTextEditor.style.display = 'block';
    this.updateInlineTextEditorPosition();
    this.autoSizeInlineTextEditorToContent();
    this.controls.inlineTextEditor.focus();
    this.controls.inlineTextEditor.setSelectionRange(0, this.controls.inlineTextEditor.value.length);
  };

  ScaleBarBuilder.prototype.autoSizeInlineTextEditorToContent = function () {
    var editor = this.controls.inlineTextEditor;
    if (!editor || editor.style.display === 'none') {
      return;
    }
    var currentWidth = parseNumber(editor.style.width, editor.offsetWidth || 0);
    var currentHeight = parseNumber(editor.style.height, editor.offsetHeight || 0);
    var minWidth = Math.max(38, parseNumber(editor.dataset.baseWidthPx, currentWidth));
    var minHeight = Math.max(20, parseNumber(editor.dataset.baseHeightPx, currentHeight));
    var nextWidth = Math.max(minWidth, currentWidth, editor.scrollWidth + 4);
    editor.style.height = 'auto';
    var nextHeight = Math.max(minHeight, editor.scrollHeight + 4);
    editor.style.width = nextWidth + 'px';
    editor.style.height = nextHeight + 'px';
  };

  ScaleBarBuilder.prototype.stopInlineTextEditing = function (applyChanges) {
    if (!this.inlineTextEditing) {
      this.controls.inlineTextEditor.style.display = 'none';
      return;
    }
    var overlay = this.findOverlayById(this.inlineTextEditing);
    if (overlay && applyChanges) {
      overlay.text = this.controls.inlineTextEditor.value || '';
      if (this.view) {
        var editor = this.controls.inlineTextEditor;
        var editorWidthPx = Math.max(24, parseNumber(editor.style.width, editor.offsetWidth || 24));
        var editorHeightPx = Math.max(14, parseNumber(editor.style.height, editor.offsetHeight || 14));
        var nextWmm = editorWidthPx * this.pixelRatio / Math.max(0.0001, this.view.scale);
        var nextHmm = editorHeightPx * this.pixelRatio / Math.max(0.0001, this.view.scale);
        var textTopLeftX = typeof overlay._computedXmm === 'number' ? overlay._computedXmm : overlay.xMm;
        var textTopLeftY = typeof overlay._computedYmm === 'number' ? overlay._computedYmm : overlay.yMm;
        overlay.wMm = Math.max(2, nextWmm);
        overlay.hMm = Math.max(2, nextHmm);
        overlay.xMm = textTopLeftX;
        overlay.yMm = textTopLeftY;
        this.clampOverlayToPrintable(overlay, this.getPaper());
      }
    }
    this.inlineTextEditing = null;
    this.controls.inlineTextEditor.style.display = 'none';
    this.render();
    if (applyChanges) {
      this.commitHistory();
    }
  };

  ScaleBarBuilder.prototype.updateInlineTextEditorPosition = function () {
    if (!this.inlineTextEditing || !this.view) {
      return;
    }
    var overlay = this.findOverlayById(this.inlineTextEditing);
    if (!overlay) {
      return;
    }
    var canvasRect = this.canvas.getBoundingClientRect();
    var wrapRect = this.controls.canvasWrap.getBoundingClientRect();
    var canvasOffsetX = canvasRect.left - wrapRect.left;
    var canvasOffsetY = canvasRect.top - wrapRect.top;
    var xMm = typeof overlay._computedXmm === 'number' ? overlay._computedXmm : overlay.xMm;
    var yMm = typeof overlay._computedYmm === 'number' ? overlay._computedYmm : overlay.yMm;
    var wMm = Math.max(2, overlay._computedWmm || overlay.wMm || 20);
    var hMm = Math.max(2, overlay._computedHmm || overlay.hMm || 10);
    var topLeft = this.paperToCanvas(xMm, yMm, this.view);
    this.controls.inlineTextEditor.style.left = (canvasOffsetX + (topLeft.x / this.pixelRatio)) + 'px';
    this.controls.inlineTextEditor.style.top = (canvasOffsetY + (topLeft.y / this.pixelRatio)) + 'px';
    this.controls.inlineTextEditor.style.width = (wMm * this.view.scale / this.pixelRatio) + 'px';
    this.controls.inlineTextEditor.style.height = (hMm * this.view.scale / this.pixelRatio) + 'px';
    this.controls.inlineTextEditor.dataset.baseWidthPx = (wMm * this.view.scale / this.pixelRatio).toFixed(2);
    this.controls.inlineTextEditor.dataset.baseHeightPx = (hMm * this.view.scale / this.pixelRatio).toFixed(2);
    this.controls.inlineTextEditor.style.fontSize = Math.max(6, this.getOverlayFontSizeMm(overlay) * this.view.scale / this.pixelRatio) + 'px';
    this.controls.inlineTextEditor.style.fontFamily = '"' + (overlay.fontFamily || this.state.defaultFontFamily) + '", sans-serif';
    this.controls.inlineTextEditor.style.color = overlay.color || '#000000';
    this.controls.inlineTextEditor.style.textAlign = overlay.align || 'left';
    this.controls.inlineTextEditor.style.lineHeight = '1.25';
    this.controls.inlineTextEditor.style.whiteSpace = 'pre-wrap';
    this.controls.inlineTextEditor.style.overflowWrap = 'anywhere';
    this.controls.inlineTextEditor.style.wordBreak = 'break-word';
    this.controls.inlineTextEditor.style.resize = 'both';
    this.controls.inlineTextEditor.style.overflow = 'auto';
    this.controls.inlineTextEditor.style.transformOrigin = 'center center';
    this.controls.inlineTextEditor.style.transform = 'rotate(' + this.normalizeRotation(overlay.rotationDeg || 0) + 'deg)';
  };

  ScaleBarBuilder.prototype.loadBackgroundFromFile = function (file) {
    var self = this;
    if (!file) {
      return;
    }

    var reader = new FileReader();
    reader.onload = function () {
      self.state.background.imageDataUrl = String(reader.result || '');
      self.state.background.mode = 'image';
      self.controls.backgroundMode.value = 'image';
      self.setStatus('Background image loaded.');
      self.render();
      self.commitHistory();
    };
    reader.readAsDataURL(file);
  };

  ScaleBarBuilder.prototype.setStatus = function (message, isError) {
    this.controls.status.textContent = message;
    this.controls.status.style.color = isError ? '#9b2c2c' : '#1f7a4f';
  };
})();
